import React, { useState, useEffect } from 'react'
import PatientService from '../../../../../../../services/api/patient.service'
import moment from 'moment'
import ModalBox from '../../../../../../templates/components/ModalBox'
import NoteEdit from '../../../../note/note-edit/NoteEdit'
import NoteAdd from '../../../../note/note-add/NoteAdd'
import NoResults from '../../../../../../templates/components/NoResults'
import Table2 from '../../../../../../templates/components/Table2'

const tableColumns = [
    {
        id: "createdOn",
        Header: "Created On",
        accessor: (row) => row.createdOn ? moment(row.createdOn).format("MM-DD-YYYY h:mm A") : ""
    },
    {
        id: "patientDetails",
        Header: "Patient",
        accessor: (row) => {
            return row.patientDetails
                ? `${row.patientDetails.firstName} ${row.patientDetails.lastName}`
                : "";
        }
    },
    {
        id: "title",
        Header: "Title",
        accessor: (row) => row.title || "",
    },
    {
        id: "description",
        Header: "Description",
        accessor: (row) => row.description || "",
    }
];

const PCNoteList = (props) => {
    const [notes, setNotes] = useState()
    const [showEdit, setShowEdit] = useState(false)
    const [showAdd, setShowAdd] = useState(false)
    const [editNote, setEditNote] = useState()
    const [showDetails, setShowDetails] = useState(false)


    useEffect(() => {
        if (props.autoPull) {
            pullNotes()
        }
        else if (props.pull) {
            pullNotes()
        }
    }, [props.autoPull, props.pull, props.keyword])

    const pullNotes = () => {
        let reqObj = {
            StartRow: 0,
            SortField: 'CreatedOn',
            Asc: false,
        };

        if (props.patientId) {
            reqObj = { ...reqObj, PatientIds: props.patientId };
        }

        return PatientService.findNotes(reqObj)
            .then(res => {
                if (props.onlyShowPatientNotes) {
                    const patientNotesList = Array.isArray(res?.data)
                        ? res.data.filter(obj => obj?.createdBy?.toLowerCase() !== "system")
                        : [];

                    setNotes(patientNotesList);
                } else {
                    setNotes(res.data || []);
                }
            })
            .catch(err => {
                console.error("Error fetching notes:", err);
                setNotes([]);
            });
    };

    const changeShowDetails = (id) => {
        if (id === showDetails) {
            setShowDetails()
        }
        else (
            setShowDetails(id)
        )
    }
    useEffect(() => {
        if (props.refresh && props.pull) {
            pullNotes()
        }
    }, [props.refresh])
    return (
        <div className='row d-flex justify-content-start g-3'>
            {notes && notes?.length>0 && <Table2
                data={notes.filter(obj => obj.createdBy?.toLowerCase() !== 'system')}
                columns={tableColumns}
                //loading={props?.loading}
                export
                hidden={true}
                title="Patient Notes"
            />}
            {notes?.length>0 ? notes.map((note, i) => {
                return (
                    <div className="col-lg-3 col-md-6 col-12">
                        <div className='p-3 corner-note-faded'>
                            <div className="row-fluid align-items-center d-flex point" onClick={e => { e.preventDefault(); if (showDetails === i) { setShowDetails(null) } else { setShowDetails(i) } }}>
                                <div className='col'>
                                    {/* <strong className='me-4'>
                                    {moment(note.createdOn).format("MM/DD/YYYY")}
                                    </strong> */}
                                    <span> {note.title != null ? note.title : '--'}</span>
                                </div>
                                {/* <div className='col-auto'>
                                    <strong> {label.note.find.createdOn} </strong>{moment(note.createdOn).format("MM/DD/YYYY")}
                                </div> */}
                                <div className='col-auto'>
                                    <button className='btn btn-transparent' onClick={e => { e.preventDefault(); setEditNote(note); return setShowEdit(true) }} title="Edit Note">
                                        <i className='icon pencil' />
                                    </button>
                                </div>
                                <div className='col-auto'>
                                    <button className='btn btn-transparent' onClick={e => { e.preventDefault(); changeShowDetails(i) }} title="Show Details">
                                        <i className={showDetails === i ? 'icon eye slash outline' : 'icon eye'} />
                                    </button>
                                </div>
                            </div>
                            {showDetails === i && <div style={{ cursor: 'default' }}>
                                <hr />
                                {
                                    note.description != '' ?
                                        note.description : '--'
                                }
                            </div>}
                        </div>
                    </div>
                )
            }) :
                <NoResults>There are Currently no Notes for this user. <a href="#" onClick={e => { e.preventDefault(); setShowAdd(true) }}>Add a Note</a></NoResults>
            }
            <ModalBox open={showEdit} onClose={() => { setShowEdit(false) }} title="Edit Note">
                <NoteEdit initialData={editNote} onClose={() => { setShowEdit(false) }} refresh={() => {pullNotes()}} />
            </ModalBox>
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }} title="Add Note">
                <NoteAdd initialData={{ patientId: props.patientId }}  onClose={() => { setShowAdd(false) }} refresh={() => {pullNotes()}}/>
            </ModalBox>
        </div>
    )
}

export default PCNoteList